import { useSnackbarStore } from '@/store/snackbar'

export function useSnackbar() {
  const store = useSnackbarStore()

  return {
    success(message, options = {}) {
      return store.push({ ...options, type: 'success', message })
    },
    error(message, options = {}) {
      return store.push({ ...options, type: 'error', message })
    },
    warning(message, options = {}) {
      return store.push({ ...options, type: 'warning', message })
    },
    info(message, options = {}) {
      return store.push({ ...options, type: 'info', message })
    },
    remove: store.remove,
    clear: store.clear,
  }
}
